// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__nME6O","langButton":"LanguageSwitcher_langButton__GPXby","active":"LanguageSwitcher_active__NRhEI"};